export const headers = {
  container_number: {
    name: "container",
    width: 0.8,
    textAlign: "left",
  },
  // importer: {
  //   name: "importer",
  //   width: 0.7,
  //   textAlign: "left",
  // },
  // type: {
  //   name: "type",
  //   width: 0.3,
  //   textAlign: "left",
  // },
  // size: {
  //   name: "size",
  //   width: 0.3,
  //   textAlign: "left",
  // },
  deliver_to: {
    name: "delivery to",
    width: 0.8,
    textAlign: "left",
  },
  country_state: {
    name: "state",
    width: 0.8,
    textAlign: "left",
  },
  etd: {
    name: "etd",
    width: 0.6,
    textAlign: "left",
  },
  eta_store: {
    name: "eta",
    width: 0.6,
    textAlign: "left",
    isSort: true,
    sortDirection: "asc",
  },
  // dd_number: {
  //   name: "ddNumber",
  //   width: 0.5,
  //   textAlign: "left",
  // },
  // coo_number: {
  //   name: "cooNumber",
  //   width: 0.5,
  //   textAlign: "left",
  // },
  status: {
    name: "status",
    width: 0.6,
    textAlign: "left",
  },
  priority: {
    name: "priority",
    width: 0.3,
    textAlign: "left",
  },
  // created_by: {
  //   name: "createdBy",
  //   width: 0.8,
  //   textAlign: "left",
  // },
  "": {
    name: "",
    width: 0.45,
    textAlign: "",
  },
};

export const mdHeaders = {
  container_number: {
    name: "container",
    width: 0.5,
    textAlign: "left",
  },
  deliver_to: {
    name: "delivery to",
    width: 1,
    textAlign: "left",
  },
  country_state: {
    name: "state",
    width: 1,
    textAlign: "left",
  },
  etd: {
    name: "etd",
    width: 0.5,
    textAlign: "left",
  },
  eta_store: {
    name: "eta",
    width: 0.5,
    textAlign: "left",
    isSort: true,
    sortDirection: "asc",
  },
  status: {
    name: "status",
    width: 0.4,
    textAlign: "left",
  },
  priority: {
    name: "priority",
    width: 0.3,
    textAlign: "left",
  },
  "": {
    name: "",
    width: 0.6,
    textAlign: "",
  },
};

export const smHeaders = {
  container_number: {
    name: "container",
    width: 0.5,
    textAlign: "left",
  },
  // etd: {
  //   name: "etd",
  //   width: 0.3,
  //   textAlign: "left",
  // },
  eta_store: {
    name: "eta",
    width: 0.3,
    textAlign: "left",
    isSort: true,
    sortDirection: "asc",
  },
  "": {
    name: "",
    width: 0.3,
    textAlign: "",
  },
};
